export const TAB_FILTER = {
  All: 'all',
  Live: 'live',
  Drafts: 'drafts',
  Completed: 'completed',
} as const;

export type TabFilter = (typeof TAB_FILTER)[keyof typeof TAB_FILTER];
